import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { Fragment } from "react";
import {
  BreadcrumbContainer,
  BreadcrumbLinkStyled,
  BreadcrumbStyled,
  ContainerStyled,
  MaterialUiLinkStyled,
  TitleStyled,
} from "./styles";

export default function SharedStaticPageHeader(props) {
  const { page } = props;
  const links = [
    {
      label: "Jobs by Specialisation",
      slug: "jobs-by-specialisation",
    },
    {
      label: "Jobs by Location",
      slug: "jobs-by-location",
    },
    {
      label: "Jobs by Job Type",
      slug: "jobs-by-type",
    },
    {
      label: "Jobs by Experience Level",
      slug: "jobs-by-experience-level",
    },
    {
      label: "Jobs by Company",
      slug: "jobs-by-company",
    },
    {
      label: "Jobs by Location and Specialisation",
      slug: "jobs-by-location-and-specialisation",
    },
    {
      label: "Jobs by Location and Job Type",
      slug: "jobs-by-location-and-type",
    },
    {
      label: "Jobs by Location and Experience Level",
      slug: "jobs-by-location-and-experience-level",
    },
    {
      label: "Jobs by Specialisation and Job Type",
      slug: "jobs-by-specialisation-and-type",
    },
    {
      label: "Jobs by Specialisation and Experience Level",
      slug: "jobs-by-specialisation-and-experience-level",
    },
  ];

  const checkCurrentPage = (page, label) => {
    if (page == label) {
      return true;
    } else return false;
  };

  return (
    <Fragment>
      <BreadcrumbContainer style={{ marginBottom: "30px" }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <BreadcrumbLinkStyled
            href="/sitemap"
            style={{
              color: "rgb(112, 112, 112)",
              fontSize: "14px",
              textDecoration: "none",
              transition: "color 0.2s ease",
              "&:hover": {
                textDecoration: "none",
                color: "#512ACC",
              },
            }}
          >
            Site Map
          </BreadcrumbLinkStyled>
          <BreadcrumbStyled
            style={{
              fontSize: "14px",
              color: "#000",
            }}
          >
            {page}
          </BreadcrumbStyled>
        </Breadcrumbs>
      </BreadcrumbContainer>

      <TitleStyled
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          marginBottom: "20px",
        }}
      >
        Browse jobs by
      </TitleStyled>
      <ContainerStyled style={{ display: "flex", flexWrap: "wrap" }}>
        {links.map(({ label, slug }) => {
          const isActive = page === label;
          return (
            <MaterialUiLinkStyled
              style={{
                color: isActive ? "#512ACC" : "#000",
                fontSize: "14px",
                fontWeight: isActive ? "bold" : "normal",
                margin: "0 30px 25px 0",
                textDecoration: "none",
                transition: "color 0.2s ease",

                "&:hover": {
                  textDecoration: "none",
                  color: "#512ACC",
                },
              }}
              key={slug}
              href={`/sitemap/${slug}`}
              $current_page={isActive}
              aria-current={isActive ? "page" : undefined}
            >
              {label}
            </MaterialUiLinkStyled>
          );
        })}
      </ContainerStyled>
    </Fragment>
  );
}
